/* eslint-disable @typescript-eslint/no-unused-vars */
import { CreateNoticeNav } from './nav-head';
import styles from './index.module.scss';
import { CommonCard } from '../../../../components/card';
import getFormatMessage from '../../../../locales/get-format-message';
import { ConsoleForm } from '../../../../components/form';
import { Dropdown, Form, Input, Switch } from 'antd';
import { CommonSelect } from '../../../../components/select';
import { useForm } from 'antd/lib/form/Form';
import { ReactNode, useEffect, useRef, useState } from 'react';
import addIcon from '../../../../assets/svg/add-circle.svg';

import ReactDOM from 'react-dom';
import { IScopeValue, ScopeSelector } from './scope-selector';
import {
  CancelButton,
  CommonButton,
  CommonButtonGroup,
  SubmitButton,
} from '../../../../components/button/main';
import {
  addNotice,
  getNoticeDetail,
  noticeEmailPreview,
  updateNotice,
} from '../../../../api';
import {
  IApiNoticeCreateRes,
  IApiNoticeItem,
  NoticeSystemBusiness,
  NoticeSystemEnable,
  NoticeSystemStatus,
} from '../../../../model/api-modules';
import { useHistory } from 'react-router-dom';
import { VDitorInput, IVDitorRef } from '../../components/vditor-input';
import { messageError, messageSuccess } from '../../../../components/message';
import { renderStatusTag } from '../lib';
import { getLocalTime } from '../../../../lib';
import { FieldData } from 'rc-field-form/lib/interface';
import { getCosFullURL, putNoticeObject } from '../lib/upload';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../store/reducers';

interface IFormInfo {
  title?: string;
  scope?: IScopeValue;
  mailContent?: string;
  myOAEnable?: boolean;
}

export const CreateUpdateNotice = (props: { id?: string }) => {
  const { id } = props;
  const history = useHistory();
  const [form] = useForm<IFormInfo>();
  const [formInfo, setFormInfo] = useState<IFormInfo>({});
  const [noticeDetail, setNoticeDetail] = useState<IApiNoticeItem>();
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [uploading, setUploading] = useState<boolean>(false);
  const [saveDrafting, setSaveDrafting] = useState<boolean>(false);
  const initMailContent = useRef<string>('');
  const vditor = useRef<IVDitorRef>();
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    if (!id) {
      return;
    }
    const res = await getNoticeDetail(id);
    if (!res) {
      return;
    }
    setNoticeDetail(res);

    const initFormInfo = {
      title: res.Title,
      scope: {
        condition: res.ScopeCondition,
        result: res.ScopeResult,
        notSelected: res.ScopeResultNotSelected,
      },
      mailContent: getInnerMailContent(res.MailContent),
      myOAEnable: res.MyOAEnable === NoticeSystemEnable.Enable,
    };
    initMailContent.current = initFormInfo.mailContent;
    setFormInfo(initFormInfo);
    form.setFieldsValue(initFormInfo);
  };

  const getInnerMailContent = (mailContent: string) => {
    const container = document.createElement('div');
    container.innerHTML = mailContent;
    return container.querySelector('.vditor-notice-view')?.innerHTML || '';
  };

  const isFormValid = () => {
    return formInfo.mailContent && formInfo.scope && formInfo.title;
  };

  const saveNotice = async ({ isDraft = false } = {}) => {
    const formData = await form.validateFields();

    if (!formData.scope || !formData.title || !formData.mailContent) {
      return null;
    }

    const cssContent = `<style>
		
		.vditor-notice-view {
    color: #24292e;
    font-variant-ligatures: no-common-ligatures;
    font-family: "Helvetica Neue","Luxi Sans","DejaVu Sans","Hiragino Sans GB","Microsoft Yahei",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji","Segoe UI Symbol","Android Emoji","EmojiSymbols";
    word-wrap: break-word;
    overflow: auto;
    line-height: 1.5;
    font-size: 16px;
    word-break: break-word
}

.vditor-notice-view--anchor {
    padding-left: 20px
}

.vditor-notice-view--error {
    color: #d23f31;
    font-size: 12px;
    display: block;
    line-height: 16px
}

.vditor-notice-view ul ul ul {
    list-style-type: square
}

.vditor-notice-view ul ul {
    list-style-type: circle
}

.vditor-notice-view ul {
    list-style-type: disc
}

.vditor-notice-view ul,.vditor-notice-view ol {
    padding-left: 2em;
    margin-top: 0;
    margin-bottom: 16px
}

.vditor-notice-view li+li {
    margin-top: 0.25em
}

.vditor-notice-view audio {
    max-width: 100%
}

.vditor-notice-view audio:focus {
    outline: none
}

.vditor-notice-view video {
    max-height: 90vh;
    max-width: 100%
}

.vditor-notice-view img {
    max-width: 100%
}

.vditor-notice-view img.emoji {
    cursor: auto;
    max-width: 20px;
    vertical-align: sub
}

.vditor-notice-view h1,.vditor-notice-view h2,.vditor-notice-view h3,.vditor-notice-view h4,.vditor-notice-view h5,.vditor-notice-view h6 {
    margin-top: 24px;
    margin-bottom: 16px;
    font-weight: 600;
    line-height: 1.25
}

.vditor-notice-view h1:hover .vditor-anchor svg,.vditor-notice-view h2:hover .vditor-anchor svg,.vditor-notice-view h3:hover .vditor-anchor svg,.vditor-notice-view h4:hover .vditor-anchor svg,.vditor-notice-view h5:hover .vditor-anchor svg,.vditor-notice-view h6:hover .vditor-anchor svg {
    visibility: visible
}

.vditor-notice-view h1 {
    font-size: 1.75em
}

.vditor-notice-view h2 {
    font-size: 1.55em
}

.vditor-notice-view h3 {
    font-size: 1.38em
}

.vditor-notice-view h4 {
    font-size: 1.25em
}

.vditor-notice-view h5 {
    font-size: 1.13em
}

.vditor-notice-view h6 {
    font-size: 1em
}

.vditor-notice-view hr {
    height: 2px;
    padding: 0;
    margin: 24px 0;
    background-color: #eaecef;
    border: 0
}

.vditor-notice-view p {
    margin-top: 0;
    margin-bottom: 16px
}

.vditor-notice-view blockquote {
    padding: 0 1em;
    color: #6a737d;
    border-left: 0.25em solid #eaecef;
    margin: 0 0 16px 0
}

.vditor-notice-view blockquote>:first-child {
    margin-top: 0
}

.vditor-notice-view blockquote>:last-child {
    margin-bottom: 0
}

.vditor-notice-view ins>iframe {
    border: 0
}

.vditor-notice-view iframe {
    border: 1px solid #d1d5da;
    max-width: 100%;
    box-sizing: border-box
}

.vditor-notice-view iframe.iframe__video {
    min-width: 80%;
    min-height: 36vh
}

.vditor-notice-view table {
    border-collapse: collapse;
    empty-cells: show;
    margin-bottom: 16px;
    overflow: auto;
    border-spacing: 0;
    display: block;
    word-break: keep-all;
    width: 100%
}

.vditor-notice-view table tr {
    background-color: #fafbfc;
    border-top: 1px solid #c6cbd1
}

.vditor-notice-view table td,.vditor-notice-view table th {
    padding: 6px 13px;
    border: 1px solid #dfe2e5;
    word-break: normal;
    white-space: nowrap
}

.vditor-notice-view table td:first-child::after,.vditor-notice-view table th:first-child::after {
    content: "";
    display: inline-block;
    vertical-align: top;
    min-height: 24px
}

.vditor-notice-view table th {
    font-weight: 600
}

.vditor-notice-view table tbody tr:nth-child(2n) {
    background-color: #fff
}

.vditor-notice-view code:not(.hljs):not(.highlight-chroma) {
    padding: 0.2em 0.4em;
    margin: 0;
    font-size: 85%;
    border-radius: 3px;
    font-family: mononoki,Consolas,"Liberation Mono",Menlo,Courier,monospace,"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji","Segoe UI Symbol","Android Emoji","EmojiSymbols";
    word-break: break-word;
    background-size: 20px 20px;
    white-space: pre-wrap
}

.vditor-notice-view pre {
    margin: 1em 0
}

.vditor-notice-view pre>code {
    margin: 0;
    font-size: 85%;
    padding: 0.5em;
    border-radius: 5px;
    display: block;
    overflow: auto;
    white-space: pre;
    font-family: mononoki,Consolas,"Liberation Mono",Menlo,Courier,monospace,"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji","Segoe UI Symbol","Android Emoji","EmojiSymbols";
    background-size: 20px 20px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8AgMAAABHkjHhAAAACVBMVEWAgIBaWlo+Pj7rTFvWAAAAA3RSTlMHCAw+VhR4AAAA+klEQVQoz4WSMW7EQAhFPxKWNh2FCx+HkaZI6RRb5DYbyVfIJXLKDCFoMbaTKSw/8ZnPAPjaH2xgZcUNUDADD7D9LtDBCLZ45fbkvo/30K8yeI64pPwl6znd/3n/Oe93P3ho9qeh72btTFzqkz0rsJle8Zr81OLEwZ1dv/713uWqvu2pl+k0fy7MWtj9r/tN5q/02z89qa/L4Dc2LvM93kezPfXlME/O86EbY/V9GB9ePX8G1/6W+/9h1dq/HGfTfzT3j/xNo7522Bfnqe5jO/fvhVthlfk434v3iO9zG/UOphyPeinPl1J8Gtaa7xPTa/Dk+RIs4deMvwGvcGsmsCvJ0AAAAABJRU5ErkJggg==);
    word-break: initial;
    word-wrap: normal
}

.vditor-notice-view pre:hover div.vditor-copy {
    display: block
}

.vditor-notice-view .language-math,.vditor-notice-view .language-echarts,.vditor-notice-view .language-mindmap,.vditor-notice-view .language-plantuml,.vditor-notice-view .language-mermaid,.vditor-notice-view .language-abc,.vditor-notice-view .language-flowchart,.vditor-notice-view .language-graphviz {
    margin-bottom: 16px
}

.vditor-notice-view .language-math mjx-container:focus {
    outline: none;
    cursor: context-menu
}

.vditor-notice-view .language-echarts,.vditor-notice-view .language-mindmap {
    overflow: hidden;
    height: 420px
}

.vditor-notice-view .language-mermaid,.vditor-notice-view .language-flowchart,.vditor-notice-view .language-graphviz {
    text-align: center
}

.vditor-notice-view .language-graphviz parsererror {
    overflow: auto
}

.vditor-notice-view kbd {
    display: inline-block;
    padding: 3px 5px;
    font: 11px Consolas, "Liberation Mono", Menlo, Courier, monospace;
    line-height: 10px;
    color: #24292e;
    vertical-align: middle;
    background-color: #fafbfc;
    border: solid 1px #d1d5da;
    border-radius: 3px;
    box-shadow: inset 0 -1px 0 #d1d5da
}

.vditor-notice-view summary {
    cursor: pointer
}

.vditor-notice-view summary:focus {
    outline: none
}

.vditor-notice-view svg {
    height: auto;
    width: auto;
    stroke-width: initial
}

.vditor-notice-view p:last-child,.vditor-notice-view blockquote:last-child,.vditor-notice-view pre:last-child,.vditor-notice-view ul:last-child,.vditor-notice-view ol:last-child,.vditor-notice-view hr:last-child {
    margin-bottom: 0
}
		</style>`;

    const body = {
      title: formData.title,
      scopeCondition: formData.scope.condition,
      scopeResult: formData.scope.result,
      scopeResultNotSelected: formData.scope.notSelected,
      mailContent: `${cssContent}<div class="vditor-notice-view">${formData.mailContent}</div>`,
      myOAEnable: formData.myOAEnable
        ? NoticeSystemEnable.Enable
        : NoticeSystemEnable.Disable,
      isDraft,
    };
    let res: IApiNoticeCreateRes | boolean = true;

    if (noticeDetail) {
      res = await updateNotice({
        id: noticeDetail.id,
        ...body,
      });
    } else {
      res = await addNotice({
        ...body,
        business: NoticeSystemBusiness.GCloud,
      });
    }

    if (!res) {
      return null;
    }

    const createdId =
      noticeDetail?.id ||
      (res instanceof Object && res.createRes.insertId) ||
      0;
    if (createdId) {
      const createInfo = await getNoticeDetail(String(createdId));
      if (createInfo) {
        setNoticeDetail(createInfo);
      }
      return createInfo;
    }
    return null;
  };

  const submitHandler = async ({ isDraft = false } = {}) => {
    if (isDraft) {
      setSaveDrafting(true);
    } else {
      setSubmitting(true);
    }
    const res = await saveNotice({ isDraft });
    setSubmitting(false);
    setSaveDrafting(false);
    if (!res) {
      isDraft
        ? getFormatMessage('保存草稿失败')
        : getFormatMessage('failed_submit');
      return null;
    }
    messageSuccess(
      isDraft ? getFormatMessage('保存草稿成功') : getFormatMessage('提交成功')
    );

    goBack();
  };

  const goBack = () => {
    history.push(`/admin/notice/list${location.search}`);
  };

  const renderFooterButtons = () => {
    const btns: ReactNode[] = [];
    if (
      !noticeDetail ||
      [NoticeSystemStatus.Draft, NoticeSystemStatus.PendingUpdate].includes(
        noticeDetail.Status
      )
    ) {
      btns.push(
        <SubmitButton
          disabled={saveDrafting || !isFormValid()}
          loading={submitting}
          onClick={() => submitHandler()}
        >
          {getFormatMessage('submit')}
        </SubmitButton>,
        <CommonButton
          loading={saveDrafting}
          disabled={submitting || !isFormValid()}
          onClick={() => submitHandler({ isDraft: true })}
        >
          {getFormatMessage('notice_save_draft')}
        </CommonButton>
      );
    }

    btns.push(
      <CancelButton onClick={goBack}>{getFormatMessage('cancel')}</CancelButton>
    );
    return btns;
  };

  const renderTitle = () => {
    if (noticeDetail) {
      return (
        <span>
          {getFormatMessage('notice_title')}
          {renderStatusTag(noticeDetail.Status)}
        </span>
      );
    }
    return <span>{getFormatMessage('notice_create')}</span>;
  };

  const renderRejectCard = () => {
    if (!noticeDetail?.ReasonReject) {
      return null;
    }

    return (
      <CommonCard title={getFormatMessage('notice_edit')}>
        <div>
          <div>
            {getLocalTime(
              noticeDetail.ModifyTime,
              userInfo?.UserSettings?.Timezone
            )}
          </div>
          <div>{noticeDetail.ReasonReject}</div>
        </div>
      </CommonCard>
    );
  };

  const emailPreview = async () => {
    const res = await saveNotice({ isDraft: true });
    if (res && res instanceof Object) {
      const sendRes = await noticeEmailPreview(res.id);
      if (sendRes) {
        messageSuccess(getFormatMessage('notice_send_success'));
        return;
      }
      messageError(getFormatMessage('notice_send_fail'));
    }
  };
  const renderContentTitle = () => {
    return (
      <div className={styles.contentLabel}>
        <span>{getFormatMessage('notice_content')}</span>
        <CommonButton type="link" onClick={emailPreview}>
          {getFormatMessage('notice_email_preview')}
        </CommonButton>
      </div>
    );
  };

  const onFieldsChange = (fields: FieldData[]) => {
    const newValues = fields.reduce<IFormInfo>((acc, field) => {
      return { ...acc, [field.name as string]: field.value };
    }, {});

    setFormInfo({ ...formInfo, ...newValues });
  };

  const insertVar = (name: string) => {
    /* const mailContent = form.getFieldValue('mailContent') || '';
    const newMailContent = `${mailContent}<p>{{${name}}}</p>`;
    setFormInfo({
      ...form.getFieldsValue(),
      mailContent: newMailContent,
    });
    vditor.current?.setValue(newMailContent);
    */

    setTimeout(() => {
      vditor.current?.insertValue(`{{${name}}}`);
    }, 100);
  };

  const renderInsertAction = () => {
    ReactDOM.render(
      <Dropdown
        trigger={['click']}
        destroyPopupOnHide={true}
        menu={{
          items: [
            {
              key: 'label',
              type: 'group',
              label: getFormatMessage('notice_insert_field'),
              children: [
                {
                  key: 'GameID',
                  label: 'GameID',
                  onClick() {
                    insertVar('gameID');
                  },
                },
                {
                  key: 'GameName',
                  label: 'GameName',
                  onClick() {
                    insertVar('gameName');
                  },
                },
              ],
            },
          ],
        }}
      >
        <img src={addIcon} />
      </Dropdown>,
      document.querySelector('#insertVarVDitorAction')
    );
  };

  const uploadImgHandler = async (file: File) => {
    const fileName = `${new Date().getTime()}-${file.name}`;
    setUploading(true);
    await putNoticeObject(fileName, file);
    setUploading(false);
    return getCosFullURL(fileName);
  };

  return (
    <div className={styles.page}>
      <CreateNoticeNav
        currentTitle={
          noticeDetail
            ? getFormatMessage('notice_modify')
            : getFormatMessage('notice_new')
        }
      />
      {renderRejectCard()}
      <CommonCard title={renderTitle()}>
        <ConsoleForm
          form={form}
          className={styles.form}
          onFieldsChange={onFieldsChange}
        >
          <Form.Item
            label={getFormatMessage('notice_method')}
            name="type"
            initialValue={getFormatMessage('notice_email')}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <CommonSelect disabled />
          </Form.Item>
          <Form.Item
            label={getFormatMessage('notice_subject')}
            name="title"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={getFormatMessage('notice_scope')}
            name="scope"
            rules={[
              {
                validator(
                  _rule: any,
                  value: string,
                  callback: (error?: string) => void
                ) {
                  if (!value) {
                    callback(getFormatMessage('notice_content_warn'));
                    return;
                  }
                  callback();
                },
              },
            ]}
          >
            <ScopeSelector />
          </Form.Item>

          <Form.Item
            label={renderContentTitle()}
            name="mailContent"
            rules={[
              {
                validator(
                  _rule: any,
                  value: string,
                  callback: (error?: string) => void
                ) {
                  if (!value) {
                    callback(getFormatMessage('notice_content_placeholder'));
                    return;
                  }
                  callback();
                },
              },
            ]}
          >
            <VDitorInput
              loading={uploading}
              ref={vditor}
              id="noticeContentVditor"
              initValue={initMailContent.current}
              placeholder={getFormatMessage('please_enter')}
              customAction={[
                {
                  name: 'add',
                  icon: '<div id="insertVarVDitorAction" />',
                  tip: getFormatMessage('notice_insert_field'),
                  tipPosition: 'n',
                  click() {},
                },
              ]}
              onInit={() => {
                renderInsertAction();
              }}
              uploadHandler={uploadImgHandler}
            />
          </Form.Item>

          <Form.Item
            label={getFormatMessage('notice_myoa_toggle')}
            name="myOAEnable"
            valuePropName="checked"
            extra={getFormatMessage('notice_myoa_reminder_desc')}
          >
            <Switch />
          </Form.Item>
        </ConsoleForm>
        <CommonButtonGroup>{renderFooterButtons()}</CommonButtonGroup>
      </CommonCard>
    </div>
  );
};
